import React, { Component } from "react";
import { connect } from "react-redux";

import { buildContentAction } from "../../services/content/actions";
import buildFiltersJson from "./build-filters-json";

import "./scss/Filters.scss";

import tracking from "../../utils/tracking";
import { HEADER_COPY, BODY_COPY } from "../../utils/content-keys";

class Filters extends Component {
  test = false;
  moduleNames = [
    { name: "Page title", title: "Title" },
    { name: "Tab name", title: "Filter" },
    { name: "Tab categories", title: "Subfilter" },
    { name: "Notice module", title: "Notice" },
    { name: "Order", title: "Order" }
  ];

  componentDidMount() {
    if (!this.props.data.fetchedData) {
      this.props.fetchData(
        {
          name: "beersFilter",
          modules: this.moduleNames,
          transform: true,
          moduleKey: "MODULES-DETAILS",
          buildJson: buildFiltersJson
        },
        true,
        "Beer Range"
      );
      return this.setPrimaryFilter(1);
    } else if (!this.props.data.built && this.props.data.data) {
      this.props.buildContentAction(this.props.data.data, {
        name: "beersFilter",
        modules: this.moduleNames,
        transform: true,
        moduleKey: "MODULES-DETAILS",
        buildJson: buildFiltersJson
      });
      return this.setPrimaryFilter(1);
    }

    this.updateFilterNames();
  }

  componentDidUpdate() {
    this.updateFilterNames();
  }

  updateFilterNames() {
    const { data, filterNames, setFilterNames } = this.props;

    if (!data.contents || filterNames.length > 0) {
      return;
    }

    let poppedContent = data.contents.order.slice(0, data.contents.order.length - 1);

    const filters = poppedContent.map(key => {
      const item = data.contents[key];

      return {
        title: item.Filter[0][HEADER_COPY].value,
        secondaryFilters: item.Subfilter.map(subfilter => ({
          title: subfilter[HEADER_COPY].value
        }))
      };
    });

    setFilterNames(filters);
  }

  setPrimaryFilter = id => {
    this.props.setFilter({
      primaryFilter: id,
      secondaryFilter: null
    });
  };

  setSecondaryFilter = id => {
    const { primaryFilter, secondaryFilter } = this.props.filters;
    const secondaryId = id === secondaryFilter ? null : id;

    this.props.setFilter({
      primaryFilter: primaryFilter,
      secondaryFilter: secondaryId
    });
  };

  render() {
    const { filterNames, filters, comingSoonIndex, data } = this.props;
    const { primaryFilter, secondaryFilter } = filters;
    const { contents } = data;

    if (!filterNames.length || !contents) {
      return null;
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="Filters col-sm-8">
            {filterNames.map((item, index) => (
              <div
                key={`primaryFilter_${index}`}
                className={`Filters__primary ${
                  primaryFilter === index + 1
                    ? "Filters__primary--selected"
                    : ""
                }`}
                onClick={() => {
                  tracking.event("customEvent", {
                    eventCategory: "Filter Usage",
                    eventAction: item.title,
                    eventLabel: index + 1
                  });
                  this.setPrimaryFilter(index + 1);
                }}
              >
                {item.title}
              </div>
            ))}
          </div>
        </div>

        {primaryFilter === comingSoonIndex && (
          <p className="beers__disclaimer">
            {
              contents[data.contents.order[comingSoonIndex - 1]].Notice[0][
                BODY_COPY
              ].value
            }
          </p>
        )}
        <div className="row d-none d-sm-block">
          {primaryFilter &&
            filterNames
              .filter((_, index) => primaryFilter === index + 1)
              .map((primary, primaryIndex) => (
                <div
                  className="Filters Filters--secondary col-sm-12"
                  key={`secondaryFilter_${primaryIndex}`}
                >
                  {primary.secondaryFilters.map((secondary, secondaryIndex) => (
                    <button
                      onClick={() => {
                        tracking.event("customEvent", {
                          eventCategory: "Filter Usage",
                          eventAction: secondary.title,
                          eventLabel: secondaryIndex + 1
                        });

                        this.setSecondaryFilter(secondaryIndex + 1);
                      }}
                      className={`Filters__secondary ${
                        secondaryFilter === secondaryIndex + 1
                          ? "Filters__secondary--selected"
                          : ""
                      }`}
                    >
                      {secondary.title}
                    </button>
                  ))}
                </div>
              ))}
        </div>
      </div>
    );
  }
}

export default connect(
  () => ({}),
  { buildContentAction }
)(Filters);



// WEBPACK FOOTER //
// ./src/pages/beers/Filters.js